import React from 'react';

/**
 * "Developed by SusTek.ai" branding strip — sits above the bottom nav.
 * Renders on every authenticated page via the Shell layout and on Login.
 */
export default function BrandFooter({ variant = 'light' }) {
  const isDark = variant === 'dark';
  return (
    <div
      data-testid="brand-footer"
      className={`px-4 py-2 border-t-2 border-carbon flex items-center justify-center gap-2 ${
        isDark ? 'bg-carbon text-canvas' : 'bg-canvas text-carbon'
      }`}
    >
      <span className="font-display text-[10px] font-bold uppercase tracking-widest opacity-70">
        Developed by
      </span>
      <a
        href="https://sustek.ai"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sustek-link"
        className="inline-flex items-center gap-1.5 hover:opacity-80 transition-opacity"
        aria-label="SusTek.ai"
      >
        <img
          src="/sustek-color.svg"
          alt="SusTek.ai"
          className="h-5 w-auto"
          data-testid="sustek-footer-logo"
        />
        <span className="font-display text-xs font-black tracking-tight">
          SusTek.ai
        </span>
      </a>
    </div>
  );
}
